"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._GenericFormScene = void 0;
/* eslint-disable no-underscore-dangle */
const formik_1 = require("formik");
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const react_router_1 = require("react-router");
const react_router_redux_1 = require("react-router-redux");
const Button_1 = require("../../components/Button/Button");
const Card_1 = require("../../components/Card/Card");
const CardTitle_1 = require("../../components/CardTitle/CardTitle");
const Loading_1 = require("../../components/Loading/Loading");
const GenericFormLayout = ({ title, children }) => (react_1.default.createElement("div", { className: "row justify-content-md-center" },
    react_1.default.createElement("div", { className: "col-lg-6" },
        react_1.default.createElement(Card_1.Card, null,
            react_1.default.createElement(CardTitle_1.CardTitle, null, title),
            children))));
const WrappedGenericFormScene = (props) => {
    const { data, EmbedForm, title, isLoading, save, context, del, fetch, initialValues, valuesFormatter, back, validate, validationSchema, user, } = props;
    const [isFetched, setIsFetched] = react_1.useState(false);
    const params = react_router_1.useParams();
    const { t } = react_i18next_1.useTranslation(context || 'GenericFormScene');
    let initValues;
    let init;
    if (typeof initialValues === 'object')
        init = initialValues;
    else
        init = initialValues({ user, params });
    if (!fetch)
        initValues = init;
    else
        initValues = Object.assign(Object.assign({}, init), data);
    if (valuesFormatter)
        initValues = valuesFormatter(initValues);
    react_1.useEffect(() => {
        if (fetch)
            fetch(params.id);
        setIsFetched(true);
    }, [fetch, setIsFetched, params.id]);
    if (isLoading || !isFetched)
        return react_1.default.createElement(Loading_1.Loading, { centeredVertical: true });
    return (react_1.default.createElement(GenericFormLayout, { title: title || t('title') },
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(formik_1.Formik, { onSubmit: fetch ? save(params.id) : save(), initialValues: initValues, validate: validate, validationSchema: validationSchema }, () => (react_1.default.createElement(formik_1.Form, null,
                react_1.default.createElement(EmbedForm, { user: user, initialValues: data }),
                react_1.default.createElement(Button_1.Button, { id: "GenericFormScene-back", onClick: back }, t('back')),
                react_1.default.createElement(Button_1.Button, { type: "submit", id: "GenericFormScene-submit", className: "float-right" }, t('save'))))),
            del ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("hr", null),
                react_1.default.createElement(Button_1.Button, { id: "delete-button", color: "danger", onClick: del(params.id) }, t('delete')))) : (undefined))));
};
const mapDispatchToProps = (dispatch, { redirectUrl, fetchAction, delAction, saveAction }) => {
    const updateOpts = { redirect: redirectUrl };
    const out = {
        back: () => dispatch(react_router_redux_1.goBack()),
        save: (id) => (body) => {
            if (id)
                dispatch(saveAction(id, body, updateOpts));
            else
                dispatch(saveAction(body, updateOpts));
        },
    };
    if (fetchAction)
        out.fetch = (id) => dispatch(fetchAction(id));
    if (delAction)
        out.del = (id) => () => dispatch(delAction(id));
    return out;
};
const mapStateToProps = (store, { reduxEntry, mapUser }) => {
    const map = {
        data: store[reduxEntry].model.data,
        user: undefined,
        isLoading: store[reduxEntry].model.isLoading,
    };
    if (mapUser) {
        map.user = store.user.model.data;
    }
    return map;
};
exports._GenericFormScene = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(WrappedGenericFormScene);
//# sourceMappingURL=_GenericFormScene.js.map